/**
 * LitigationHold.jsx — Subtab VI
 */

import React from "react";
import { EphemeralFlow } from "../diagrams.jsx";
import { SubtabHeading, GapBlock, SolutionLead, Body, P } from "../SubtabFrame.jsx";

export default function LitigationHold() {
  return (
    <article>
      <SubtabHeading roman="VI">Litigation Hold and Discoverability of AI Artifacts</SubtabHeading>
      <EphemeralFlow />
      <GapBlock>
        AI prompts and outputs are increasingly treated as discoverable. The
        system needs to support litigation holds without creating unnecessary
        discoverable material in routine matters.
      </GapBlock>
      <SolutionLead>
        Ephemeral-by-default inference with elective audit trails the firm
        controls per-matter.
      </SolutionLead>
      <Body>
        <P>
          Default operation produces no persistent record of prompts or
          outputs. The inference happens in volatile memory; the response is
          delivered to the requesting lawyer; the prompt and response are
          discarded at session close. No logging of substantive content, only
          operational metadata (user, timestamp, session duration, token
          counts) for billing and security purposes.
        </P>
        <P>
          When a matter is placed on litigation hold, the supervising attorney
          enables matter-level audit logging through a dual-authorization
          workflow. From that point forward, prompts and outputs for that
          matter are written to an append-only WORM (write-once-read-many)
          store — Dell PowerProtect Cyber Recovery or NetApp SnapLock provides
          this at hardware level — with cryptographic timestamping (RFC 3161)
          so logs cannot be backdated or tampered with.
        </P>
        <P>
          CoConsoleX explicitly recommends that engagement letters and firm AI
          governance policies define AI prompts and outputs as "draft work
          product" by default, subject to the same protection (and the same
          litigation hold treatment) as attorney handwritten notes and draft
          memos. This is consistent with how Sedona Principle 1 and Rule
          26(b)(3) treat work product, and it gives firms a defensible posture
          when responding to discovery requests about AI use.
        </P>
        <P>
          CoConsoleX also recommends that firms producing privilege logs
          reference AI-generated drafts collectively rather than itemizing
          individual prompts, consistent with how draft email and document
          iterations are handled today.
        </P>
      </Body>
    </article>
  );
}
